var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"isLoading"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}}),_c('p',[_vm._v("Authorising...")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }